<template>
  <a-card :bordered="false">
    <div class=" s_flex_bian_c m-b-20">
      <span class=' mr15 '>
        <a-button type="primary" class='m-r-20' v-has:memberCustomerInfoCreate="()=> {createInfo()}">
          <PlusOutlined />
          添加
        </a-button>
      </span>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
        <a href="javascript:;" v-has:memberCustomerInfoEdit="()=> {editInfo(record)}" class="m-r-10">编辑</a>
        <a href="javascript:;" v-has:memberCustomerInfoDel="()=> {delInfo(record)}">删除</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    <a-modal :keyboard="false" :maskClosable='false' v-model:visible="visible" @ok='handleOk' destroyOnClose  centered :title="infoData.id?'修改字段':'添加字段'">
        <a-from>
            <a-form-item label="字段名称"><a-input v-model:value="infoData.field_name"></a-input></a-form-item>
        </a-from>
    </a-modal>
  </a-card>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message, Modal } from "ant-design-vue";
import {member_attach_info_config,createMemberAttachInfoConfig,updateMemberAttachInfoConfig,delMemberAttachInfoConfig} from '@/api/member'
import { iscode } from "@/utils/app";
import useTableSearch from "@/hooks/useTableSearch";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  setup() {
    const state = reactive({
      time: [],
      showAction: false,
      itemId: "",
    });
    let columns = [
      {
        title: "自定义信息字段",
        dataIndex: "field_name",
        key: "field_name",
      },
      {
        title: "创建时间",
        dataIndex: "created_time",
        key: "created_time",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    // 选择操作
    const selectAction = (type) => {};
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
       const _lodash = inject("_lodash");
    onMounted(() => {
      tableHoosks.initData(member_attach_info_config, search.value);
    });
    //
    const infoHandleHooks = () => {
      const visible = ref(false);
      const infoData = ref({field_name:"",id:null});
      // 添加
      const createInfo = (data) => {
        infoData.value = {field_name:""};
        visible.value = true;
      };
      // 修改
      const editInfo = (data) => {
        console.log(data)
        infoData.value = _lodash.cloneDeep(data);
        visible.value = true;
      };
      // 删除
      const delInfo = (data) => {
        Modal.confirm({
          centered: true,
          content: "删除后将无法恢复，您确定要删除吗？",
          onOk: async () => {
            let res = await delMemberAttachInfoConfig(data.id).then((res) => res.data);
            if (iscode(res, true)) {
                search.value.page = 1;
                tableHoosks.pageCurrentChange()
            }
          },
        });
      };
      // 确认
      const handleOk = async () => {
          let result;
          if(infoData.value.id){
            result =await updateMemberAttachInfoConfig(infoData.value.id,infoData.value).then(res=>res.data).catch(error=>error)
          }else{
            result =await createMemberAttachInfoConfig(infoData.value).then(res=>res.data).catch(error=>error)
          }
          if(iscode(result,true)){
             visible.value=false
             tableHoosks.pageCurrentChange()
          }
      };
      return {
        createInfo,
        visible,
        infoData,
        editInfo,
        handleOk,
        delInfo,
      };
    };
    return {
      ...toRefs(state),
      ...tableHoosks,
      columns,
      selectAction,
      ...infoHandleHooks(),
    };
  },
};
</script>